import { type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../../../lib/utils';

import { badgeVariants, badgeDotVariants } from './variants';

export interface BadgeProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, children, ...props }: BadgeProps) {
  const showDot = variant === 'dotted';

  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props}>
      {showDot && <div className={badgeDotVariants()} />}
      {children}
    </div>
  );
}

export { Badge };
